import Popover from 'src/components/popover/popover.vue'
import UnicodeDomainIndicator from 'src/components/unicode_domain_indicator/unicode_domain_indicator.vue'
import UserAvatar from 'src/components/user_avatar/user_avatar.vue'

import { useMergedConfigStore } from 'src/stores/merged_config.js'
import { useUsersStore } from 'src/stores/users.js'

import { profileLink } from 'src/services/user_display/user_display.js'

const UserListPopover = {
  name: 'UserListPopover',
  props: {
    userIds: Set,
  },
  components: {
    UnicodeDomainIndicator,
    Popover,
    UserAvatar,
  },
  computed: {
    users() {
      return [...this.userIds]
        .map((id) => useUsersStore().findUser(id))
        .filter(Boolean)
    },
    usersCapped() {
      return [...this.users].slice(0, 16)
    },
    allowNonSquareEmoji() {
      return useMergedConfigStore().mergedConfig.nonSquareEmoji
    },
    pauseMfm() {
      return useMergedConfigStore().mergedConfig.pauseMfm
    },
    scaleMfm() {
      return useMergedConfigStore().mergedConfig.scaleMfm
    },
  },
  methods: {
    generateProfileLink: profileLink,
  },
}

export default UserListPopover
